import React from 'react';
import { useNotifications } from '../../contexts/NotificationContext';
import { useAuth } from '../../contexts/AuthContext';

const TestNotification: React.FC = () => {
  const { addNotification } = useNotifications();
  const { userProfile } = useAuth();

  const handleTestNotification = () => {
    if (!userProfile) return;
    
    addNotification({
      userId: userProfile.uid,
      title: 'Test Notification',
      message: 'This is a test notification',
      type: 'announcement',
      isRead: false,
      relatedId: 'test-id'
    });
  };

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <button 
        onClick={handleTestNotification}
        className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md text-sm font-medium"
      >
        Test Notification
      </button>
    </div>
  );
};

export default TestNotification;
